import $ from 'jquery'

class Recorder {

    constructor(options) {
        const defaults = {
            fields: [],
            reportInterval: 10,
            callback: function(){}
        };

        this.options = $.extend({}, defaults, options);
        this.looker = null
        this.reporter = null
        this.started = false
        this.visible = true
        this.counters = {}
        this.checkViewport = this.checkViewport.bind(this)
        this.report = this.report.bind(this)
    }

    calculateVisibilityForDiv(div$) {
        let windowHeight = $(window).height(),
            docScroll = $(document).scrollTop(),
            divPosition = div$.offset().top,
            divHeight = div$.height(),
            hiddenBefore = docScroll - divPosition,
            hiddenAfter = (divPosition + divHeight) - (docScroll + windowHeight);

        if ((docScroll > divPosition + divHeight) || (divPosition > docScroll + windowHeight)) {
            return 0;
        } else {
            let result = 100;

            if (hiddenBefore > 0) {
                result -= (hiddenBefore * 100) / divHeight;
            }

            if (hiddenAfter > 0) {
                result -= (hiddenAfter * 100) / divHeight;
            }

            return result;
        }
    }

    checkViewport() {
        for (let i in this.options.fields) {
            const item = this.options.fields[i]
            const element = $(item.selector)
            if (element.length > 0 && this.calculateVisibilityForDiv(element) >= item.percentage && vis() && document.hasFocus()) {
                if (!this.counters[item.name]) {
                    this.counters[item.name] = 0
                }
                this.counters[item.name]++
            }
        }
    }
    report() {
        this.options.callback(this.counters);
    }

    start() {
        if (!this.started) {
            this.checkViewport()
            this.started = true;
        }
        this.looker = setInterval(this.checkViewport, 1000);
        this.reporter = setInterval(this.report, this.options.reportInterval * 1000);
    }

    stop() {
        this.started = true;
        clearInterval(this.looker)
        clearInterval(this.reporter)
    }

}

var vis = (function(){
    var stateKey, eventKey, keys = {
        hidden: "visibilitychange",
        webkitHidden: "webkitvisibilitychange",
        mozHidden: "mozvisibilitychange",
        msHidden: "msvisibilitychange"
    };
    for (stateKey in keys) {
        if (stateKey in document) {
            eventKey = keys[stateKey];
            break;
        }
    }
    return function(c) {
        if (c) document.addEventListener(eventKey, c);
        return !document[stateKey];
    }
})();

export default Recorder


// WEBPACK FOOTER //
// ./src/common/timespent/Recorder.jsx